"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerEventHandler = void 0;
var tslib_1 = require("tslib");
var eventDispatcher_1 = require("../../store/_infra/eventDispatcher");
function triggerEventHandler(ctx, cmd) {
    var fullEvent;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fullEvent = tslib_1.__assign(tslib_1.__assign({}, cmd.payload.eventBody), { ctx: ctx });
                return [4 /*yield*/, eventDispatcher_1.dispatchDashboardEvent(fullEvent)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports.triggerEventHandler = triggerEventHandler;
//# sourceMappingURL=triggerEventHandler.js.map